const VALID_EXTENSIONS = ['.pdf', '.doc', '.docx'];

export function supportsDirectoryPicker(): boolean {
  return typeof window !== 'undefined' && 'showDirectoryPicker' in window;
}

export async function collectFilesFromDirectory(
  dirHandle: FileSystemDirectoryHandle
): Promise<File[]> {
  const files: File[] = [];
  await collectRecursive(dirHandle, files);
  return files;
}

async function collectRecursive(
  dirHandle: FileSystemDirectoryHandle,
  files: File[]
): Promise<void> {
  for await (const entry of (dirHandle as any).values()) {
    if (entry.kind === 'file') {
      const file = await (entry as FileSystemFileHandle).getFile();
      files.push(file);
    } else if (entry.kind === 'directory') {
      await collectRecursive(entry as FileSystemDirectoryHandle, files);
    }
  }
}

export function filterByExtension(files: File[]): File[] {
  return files.filter(f => {
    const ext = f.name.slice(f.name.lastIndexOf('.')).toLowerCase();
    return VALID_EXTENSIONS.includes(ext);
  });
}
